import {CalculatorCoordinateData, CalculatorDataInterface} from './calculator.data.interface';
import * as geolib from 'geolib';
import {CountryInterface} from '../data/country.interface';
import {Store} from '../data/store';

export class Calculator
{

    private static constant : CalculatorDataInterface = {
        constantX: 417321.75,
        constantY: 222299.867
    };

    private static nullIsland : CalculatorCoordinateData = { top: 64, left: 47.2};

    public static GetCoordinates(country : CountryInterface) : CalculatorCoordinateData
    {

        let data : CalculatorCoordinateData = new class implements CalculatorCoordinateData {
            left: number;
            top: number;
        };

        let leftAdjust : number = geolib.getDistance(
            {longitude: 0, latitude: 0},
            {longitude: country.long, latitude: 0}
        ) / this.constant.constantX;

        let topAdjust : number = geolib.getDistance(
            {longitude: 0, latitude: 0},
            {longitude: 0, latitude: country.lat}
        ) / this.constant.constantY;

        if(country.long < 0)
            leftAdjust *= -1;

        if(country.lat > 0)
            topAdjust *= -1;

        data.left = this.nullIsland.left + leftAdjust;
        data.top = this.nullIsland.top + topAdjust;

        return data;
    }

    public static GetCoordinatesByCode(countryCode : string) : CalculatorCoordinateData
    {
        for(let country of Store.COUNTRIES)
        {
            if(country.code === countryCode)
                return this.GetCoordinates(country);
        }

        return this.GetCoordinates(Store.COUNTRIES[0]); // fallback
    }
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/map-chart/helper/calculator.ts